import { render } from "./LocInfo.vue?vue&type=template&id=601fd05d"
import script from "./LocInfo.vue?vue&type=script&lang=js"
export * from "./LocInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__